import { render } from "./LMSCoursesPage.vue?vue&type=template&id=79a95a48&ts=true"
import script from "./LMSCoursesPage.vue?vue&type=script&lang=ts"
export * from "./LMSCoursesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__